"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Electric.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Electric = function Electric(props) {
  return _react2.default.createElement("svg", Object.assign({
    viewBox: "0 0 54.33 79.22",
    className: "line-icon"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Electric Icon"), _react2.default.createElement("path", {
    className: "electric",
    d: "M54.34 22.48c0-3.86-3.16-5-7-5h-7.51v-14A3.45 3.45 0 0 0 36.39.04h-1a3.45 3.45 0 0 0-3.44 3.44v14h-8.21v-14A3.45 3.45 0 0 0 20.3.04h-1a3.45 3.45 0 0 0-3.44 3.44v14H7.02c-3.86 0-7 1.15-7 5 0 3.24 2.23 4 5.22 4.77-.09 1.08-.14 4.18-.14 5.3 0 14.67 7.88 26.85 18.25 29.29v14.55c0 1.57 1.71 2.83 3.83 2.83s3.83-1.27 3.83-2.83V61.85c10.36-2.45 18.24-14.63 18.24-29.3 0-1.12 0-4.22-.14-5.3 3-.8 5.23-1.53 5.23-4.77z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Electric;